import { convertToCarouselImages } from 'components/molecules/ImageCarousel/helper'

export const parseAssetData = (assetData: any) => {
  if (assetData) {
    assetData.photos = convertToCarouselImages(assetData.photos, 'url', 'memo')
  }

  return assetData
}
